import InputText from './InputText/main.vue';
import InputCheckBox from './InputCheckBox/main.vue';
import InputRadio from './InputRadio/main.vue';
import AmountInput from './AmountInput/main.vue';

export { InputText, InputCheckBox, InputRadio, AmountInput };
